import React, { useState } from "react";
import Button from "../ResubleComp/Button";
import ClusterPost from "./ClusterPost";

function ToggleCluster() {
  const [activeButton, setActiveButton] = useState("recent");

  const handleButtonClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  return (
    <div className="border m-auto mt-5 lg:w-1/2 md:w-full w-full">
      <div className="flex justify-start gap-6 mb-4">
        <Button
          onClick={() => handleButtonClick("recent")}
          className={`px-5 py-5 rounded-md lg:text-base text-sm md:text-base cursor-pointer hover:bg-transparent ${
            activeButton === "recent"
              ? "underline decoration-2 underline-offset-8 hover:bg-transparent"
              : ""
          }`}
        >
          Recent
        </Button>

        <Button
          onClick={() => handleButtonClick("top-rated")}
          className={`px-5 py-5 rounded-md lg:text-base text-sm md:text-base cursor-pointer hover:bg-transparent ${
            activeButton === "top-rated"
              ? "underline decoration-2 underline-offset-8 hover:bg-transparent"
              : ""
          }`}
        >
          Top Rated
        </Button>

        <Button
          onClick={() => handleButtonClick("top-people")}
          className={`px-5 py-5 rounded-md lg:text-base text-sm md:text-base cursor-pointer hover:bg-transparent ${
            activeButton === "top-people"
              ? "underline decoration-2 underline-offset-8 hover:bg-transparent"
              : ""
          }`}
        >
          Top People
        </Button>
      </div>
      <div className="flex justify-center">
        {activeButton === "recent" && (
          <div className="w-full ">
            <ClusterPost />
          </div>
        )}
        {activeButton === "top-rated" && (
          <p className="w-full bg-white h-[400px] p-5 border pt-36 text-2xl text-center mb-5">
            Top rated posts will be shown here based on how many people found it
            "helpful" & "Informative"
          </p>
        )}
        {activeButton === "top-people" && (
          <p className="w-full bg-white h-[400px] p-5 border pt-36 text-2xl text-center mb-5">
            Top members will be shown here based on their activity in this
            cluster. An activity will be defined based on the effectiveness of
            performance, replies & quality posts.
          </p>
        )}
      </div>
    </div>
  );
}

export default ToggleCluster;
